import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { chunkArray, calc } from "../../utils";
import { Box, Grid, Divider, Container, Tabs, Tab } from "@mui/material";
import { selectInputValues, selectLabeledInputValues, updateInput } from "./inputsSlice";
import { loadInitial, setTab } from "./outputsSlice";
import { Output } from "./Output";
import { Inputs } from "./Inputs"

function a11yProps(index) {
	return {
		id: `output-tab-${index}`,
		"aria-controls": `output-tabpanel-${index}`,
	};
}

export const ChannelMix = () => {
	const dispatch = useDispatch();
	const view = useSelector(state => state.channelMix.settings.view);
	const calcView = useSelector(state => state.calculators.view);
	const tab = useSelector(state => state.channelMix.outputs.tab);
	const { outputs } = useSelector(state => state.calculators.schema[2]);
	const calculator = useSelector(state => state.calculators.schema).find((calc) => calc.path.slice(1) === calcView);

	const tabChange = (e, newValue) => {
		dispatch(setTab(newValue));
	};

	return (
		<Box sx={{pt: 3}}>
			<Grid container spacing={2}>
				<Grid item xs={12}><Inputs /></Grid>
				<Grid item xs={12}>
					{view === "output" &&
						<Box sx={{mb: 2}}>
							<Container maxWidth="lg" sx={{maxWidth: "1600px !important", minWidth: "1600px !important"}}>
								<Tabs value={tab} onChange={tabChange} aria-label="Output Tabs">
									{calculator.outputs.map(({label, type}, key) => <Tab key={`output_tab_${key}`} {...{label}} {...a11yProps(key)} />)}
								</Tabs>
							</Container>
							<Divider/>
						</Box>
					}
					{view === "output" && outputs.map((output, key) =>
						<Box hidden={key !== tab} key={`output_${key}`}>
							<Output {...output} />
						</Box>
					)}
				</Grid>
			</Grid>
		</Box>
	);
};